module.exports = __webpack_public_path__ + "static/media/appen.cb00fc54.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appen.mp4
// module id = 422
// module chunks = 0